import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import styles from './TooltipDataItem.css';
export const TooltipDataItem = ({ label, value, }) => (_jsxs("div", Object.assign({ className: styles.item, "data-testid": "tooltipDataItem" }, { children: [_jsxs("strong", Object.assign({ className: styles.label }, { children: [label, ":"] }), void 0), _jsx("span", Object.assign({ className: styles.value }, { children: value }), void 0)] }), void 0));
export default memo(TooltipDataItem);
